module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chapter-number---IVP sigil_not_in_toc",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page7",
      "title": "7"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "veryfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgements#_idTextAnchor075"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#_idTextAnchor078"
    }
  }, [_vm._v("1 Five Images of Christ in the Postapostolic Age")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor187"
    }
  }, [_vm._v("2 Christ as Angel: Angel Adoptionism")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Christ as Prophet: Spirit Adoptionism")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Christ as Phantom: Docetism and Docetic Gnosticism")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor535",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Christ as Cosmic Mind: Hybrid Gnosticism")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idTextAnchor680",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Christ as Word: Logos Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idTextAnchor846",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 What, Then, Is Orthodoxy?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#page129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chart: Christology Continuum")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/subjectindex#_idTextAnchor1022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/scriptureindex#_idTextAnchor1023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idTextAnchor1024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("The Earliest Christologies")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author#_idTextAnchor1025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/otherbooks#_idTextAnchor1026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books by James Papandrea")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#_idTextAnchor1027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page8",
      "title": "8"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0